const LandingNonPass = () => {
    window.location.href = "http://hello.tbd.health/tbd";
}

export default LandingNonPass;
